import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, Package, ArrowRight } from "lucide-react";
import api, { formatMoney } from "../lib/apiClient";

export default function OrderConfirmation() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem(`eth_ot_${orderNumber}`);
    const url = token ? `/orders/${orderNumber}?token=${encodeURIComponent(token)}` : `/orders/${orderNumber}`;
    api.get(url).then((r) => setOrder(r.data)).catch(() => {});
  }, [orderNumber]);

  const paid = order?.status === "paid";

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-14">
      <div className="card-soft rounded-3xl p-8 sm:p-10 text-center animate-fade-up" data-testid="order-confirmation">
        <div className="w-20 h-20 mx-auto rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center">
          <CheckCircle2 className="w-10 h-10 text-emerald-600" />
        </div>
        <h1 className="font-display font-extrabold text-3xl mt-6">Order confirmed</h1>
        <p className="text-muted-foreground mt-2">
          {paid ? "Your payment was successful and your order has been recorded." : "Your order has been recorded."} A receipt has been sent to your email.
        </p>

        <div className="mt-8 space-y-3 text-left">
          <div className="bg-white border border-border rounded-xl p-4 flex items-center justify-between">
            <div><p className="text-xs text-muted-foreground">Order number</p><p className="font-display font-bold" data-testid="order-number">{orderNumber}</p></div>
            <Package className="w-5 h-5" style={{ color: "var(--gold)" }} />
          </div>
          {order?.email && (
            <div className="bg-white border border-border rounded-xl p-4 flex justify-between items-center">
              <p className="text-xs text-muted-foreground">Receipt email</p>
              <p className="text-sm font-medium" data-testid="order-email">{order.email}</p>
            </div>
          )}
          {order?.shipping_method && (
            <div className="bg-white border border-border rounded-xl p-4 flex justify-between items-center">
              <p className="text-xs text-muted-foreground">Shipping</p>
              <p className="text-sm font-medium text-right" data-testid="order-shipping">{order.shipping_method}{typeof order.shipping_cost === "number" ? ` · ${order.shipping_cost === 0 ? "Free" : formatMoney(order.shipping_cost)}` : ""}</p>
            </div>
          )}
          {order && (
            <div className="bg-white border border-border rounded-xl p-4 flex justify-between items-center">
              <p className="text-xs text-muted-foreground">Total paid</p>
              <p className="font-display font-bold text-lg" data-testid="order-total">{formatMoney(order.total)}</p>
            </div>
          )}
        </div>

        <div className="mt-6 text-xs text-amber-800 bg-amber-100/70 border border-amber-200 rounded-lg p-3" data-testid="order-review-notice">
          Your order is on hold for manual review. We’ll confirm shipping details by email before dispatch.
        </div>

        <Link to="/shop" data-testid="back-to-store" className="inline-flex mt-8 h-12 px-8 rounded-xl btn-ink font-display font-bold items-center gap-2">
          Continue shopping <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
